"use client";
import { sliceTranslate } from "../../translations/index.js";
import { VALID_ADDRESS, VALID_DIGITS, VALID_EMAIL, VALID_NAME, VALID_FIRST_CELL_PHONE_DIGIT, REG_NO_FULL_PATTERN, REG_NO_FULL_LENGTH } from "./regex.js";
import { validation, stripWhitespace } from "./validation.js";
import { matchesRegex, hasLength, maxLength } from "./validationSteps.js";
const texts = sliceTranslate((t) => t.validation.errors);
const noValidation = () => validation();
const validAddress = validation({
  steps: [
    matchesRegex(VALID_ADDRESS, texts((t) => t.invalidCharacters))
  ]
});
const validZipCode = validation({
  steps: [
    matchesRegex(VALID_DIGITS, texts((t) => t.onlyDigits)),
    hasLength(4, "digits")
  ],
  showMessageImmediately: (x) => x.length > 4
});
const validEmail = validation({
  steps: [
    matchesRegex(VALID_EMAIL, texts((t) => t.invalidEmail))
  ]
});
const validName = validation({
  steps: [
    maxLength(50),
    matchesRegex(VALID_NAME, texts((t) => t.invalidNameRegex))
  ],
  showMessageImmediately: (x) => x.length > 50,
  messagePrefix: texts((t) => t.invalidName)
});
const validCellPhoneNumber = validation({
  steps: [
    matchesRegex(VALID_FIRST_CELL_PHONE_DIGIT, texts((t) => t.invalidCellPhoneFirstDigit)),
    matchesRegex(VALID_DIGITS, texts((t) => t.onlyDigits)),
    hasLength(8, "digits")
  ],
  preValidation: stripWhitespace,
  showMessageImmediately: (x) => x.length > 8 || !VALID_FIRST_CELL_PHONE_DIGIT.test(x),
  messagePrefix: texts((t) => t.invalidPhoneNumber)
});
const validRegistrationNumber = validation({
  steps: [
    matchesRegex(REG_NO_FULL_PATTERN, texts((t) => t.invalidRegistrationNumber))
  ],
  preValidation: (x) => stripWhitespace(x).toUpperCase(),
  showMessageImmediately: (x) => x.length > REG_NO_FULL_LENGTH
});
const mustBeChecked = (message) => validation({
  steps: [
    (isChecked) => ({
      isValid: isChecked,
      errorMessage: message
    })
  ]
});
const atLeastOneMustBeChecked = (message) => validation({
  steps: [
    (selected) => ({
      isValid: selected.length > 0,
      errorMessage: message
    })
  ]
});
export {
  atLeastOneMustBeChecked,
  mustBeChecked,
  noValidation,
  validAddress,
  validCellPhoneNumber,
  validEmail,
  validName,
  validRegistrationNumber,
  validZipCode
};
